import { render, staticRenderFns } from "./StockItemsList.vue?vue&type=template&id=50f661d8&"
import script from "./StockItemsList.vue?vue&type=script&lang=js&"
export * from "./StockItemsList.vue?vue&type=script&lang=js&"
import style0 from "./StockItemsList.vue?vue&type=style&index=0&id=50f661d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports